var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.677,
    height: 24.677,
    viewBox: "0 0 24.677 24.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667",
    transform: "translate(-38.615 -210.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(38.615 210.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(1217.661 65.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M-1172.489,154.739q0-1.006,0-2.012a1.021,1.021,0,0,1,1.075-1.078q1.612,0,3.225,0a1.02,1.02,0,0,1,1.068,1.072q0,2.025,0,4.05a1.02,1.02,0,0,1-1.068,1.072q-1.619,0-3.238,0a1.02,1.02,0,0,1-1.062-1.065Q-1172.49,155.758-1172.489,154.739Zm.826.006q0,1.006,0,2.012c0,.194.063.259.251.259h3.213c.189,0,.252-.065.253-.258q0-2.012,0-4.025c0-.2-.063-.259-.265-.259h-3.187c-.206,0-.265.061-.265.271Q-1171.663,153.746-1171.663,154.745Z",
    transform: "translate(-0.002 -0.003)",
    fill: "#253766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M-987.417,310.469q0,1.006,0,2.012a1.022,1.022,0,0,1-1.075,1.078q-1.612,0-3.225,0a1.02,1.02,0,0,1-1.068-1.072q0-2.025,0-4.05a1.019,1.019,0,0,1,1.068-1.071q1.619,0,3.238,0a1.019,1.019,0,0,1,1.062,1.065Q-987.415,309.45-987.417,310.469Zm-.826-.015q0-.993,0-1.987c0-.218-.057-.276-.273-.276h-3.161c-.227,0-.282.055-.282.28q0,1.993,0,3.986c0,.218.057.276.273.276h3.174c.209,0,.269-.06.269-.267Q-988.242,311.461-988.243,310.454Z",
    transform: "translate(-173.51 -150.352)",
    fill: "#253766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M-990.121,156.188c-.533,0-1.066,0-1.6,0a1.021,1.021,0,0,1-1.072-1.068q0-1.206,0-2.412a1.018,1.018,0,0,1,1.065-1.061q1.619,0,3.238,0a1.018,1.018,0,0,1,1.065,1.061q0,1.212,0,2.425a1.019,1.019,0,0,1-1.059,1.055C-989.029,156.19-989.575,156.188-990.121,156.188Zm.019-3.716h-1.587c-.219,0-.278.057-.278.271q0,1.174,0,2.348c0,.214.058.271.278.271h3.161c.219,0,.278-.057.278-.272q0-1.174,0-2.348c0-.214-.059-.271-.278-.271Z",
    transform: "translate(-173.503)",
    fill: "#253766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M-1169.8,355.286c.537,0,1.075,0,1.612,0a1.02,1.02,0,0,1,1.068,1.072q0,1.2,0,2.4a1.021,1.021,0,0,1-1.07,1.07q-1.612,0-3.225,0a1.021,1.021,0,0,1-1.074-1.079q0-1.193,0-2.386a1.021,1.021,0,0,1,1.076-1.077Zm0,.826h-1.613c-.177,0-.245.067-.246.238q0,1.206,0,2.412c0,.172.069.239.245.239h3.225c.18,0,.246-.068.246-.251q0-1.193,0-2.386c0-.189-.065-.252-.258-.252Z",
    transform: "translate(0 -196.62)",
    fill: "#253766"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.2eccac364bc7e50ecc873abfe3859917.svg";
export { ForwardRef as ReactComponent };